import React, {PropTypes} from 'react';
import {Link, browserHistory} from 'react-router';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import DashBoardHeader from '../../header_dashboard/dashboard_header';
import ProfileNavBar from '.././profile_navbar/profile_navbar';
import validate from '../../util/validate';
import authActions from '../../auth/auth_actions';
import './trips.less'
import LogoutPopUp from '../../components/logoutPopUp/logout_pop_up';
import LoggedinFooter from '../../footer/loggedin_footer';
import ViewTrips from '../../add_trips/view_trips/view_trips';

class TripDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className = "trip-details-main-wrap">
        <ViewTrips />
      </div>
    )
  }
}

class Trips extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {props, state} = this;
    const {userData} = props.authState;
    let sessionValid = true ;
    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid
   let user = {
      name: '',
      imageUrl: '',
      isVerified: '',
      creditAmount: ''
    };

    if(props.authState) {
      user.name = userData.name;
      user.imageUrl = userData.profileImageUrl;
      user.isVerified = userData.isVerified;
      user.creditAmount = userData.creditAmount
    }
    return (
      <div className="account-details-wrap account-section">
        <DashBoardHeader user={user} logout={this.logout}/>
        <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        <div className="account-header-wrap">
          <div className="wrapper">
            <h2 className="page-header account-page-header">Account</h2>
          </div>
        </div>
        <div className="wrapper account-wrapper">
          <div className="profile-nav-bar-component">
            <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
            </div>
            <div className="account-details-component">
              <TripDetails />
            </div>
          </div>
          <LoggedinFooter />
      </div>
    )
  }
}

Trips = connect((state) => {
    return {
      authState: state.app.auth
    }
}, (dispatch) => {
    return {
        routerActions: bindActionCreators(routerActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch)
    }
})(Trips);

export default Trips;



// WEBPACK FOOTER //
// app/profile/trips/trips.jsx